import { createContext, useContext } from 'react';
import { User, Rollouts } from '../../types';
import type { CategoryWebLink } from '../../components/CategoriesNavigation/types';

interface Currency {
    code: string;
    template: string;
    symbol: string;
    name: string;
    exchange_rate: number;
    round_amount?: number;
}

interface SupportedCurrency {
    currency: string;
    currency_symbol: string;
    currency_name: string;
}

interface Category {
    id: number;
    subCategories?: { id: number; isNew?: boolean }[];
}

export interface HeaderContextValue {
    user: User;
    rollouts: Rollouts;
    locale: string;
    displayedLocale: string;
    supportedCurrencies: SupportedCurrency[];
    supportedLanguages: string[];
    currency: Currency;
    isFullWidth: boolean;
    showNaviconButton: boolean;
    abTests: Record<string, unknown>;
    notificationSoundEnabled?: boolean;
    headerType?: string;
    categories?: Category[];
    showBuyerNavigation?: boolean;
    userAgent?: string;
    requestUrl?: string;
    referrer?: string;
    pageCtxId?: string;
    subCategoryId?: number;
    categoriesCmsConfig?: CategoryWebLink;
    isNewCategoriesNavigation?: boolean;
    appName?: string;
}

export const HeaderContext = createContext<HeaderContextValue | undefined>(undefined);

export const useHeaderContext = (): HeaderContextValue => {
    const context = useContext(HeaderContext);

    if (!context) {
        throw new Error('useHeaderContext must be used within a HeaderContext.Provider');
    }

    return context;
};
